<template>
<div class="chapter">
<div class="inner_page">
<p class="block_" id="id_Hlk61959347"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_1">About the Author</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_2">Kirk Shamley is an average guy forever in search of a good story. He lives with his wife and cat while braving the wind-swept plains of Wyoming.</p>
<p class="block_3" id="calibre_pb_0"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?0ad289a1